<vng-modal
  [title]="page == 0 ? 'Sign out of FlyMSG?' : 'Before you sign out, could you tell us why?'"
  size="md"
  [closable]="true"
  (closed)="hideModal()">
  <div vngModalBody class="sign-out-message">
    <div class="first" *ngIf="page == 0">
      <div class="top">
        <span>This will sign you out of FlyMSG on all websites.</span>
      </div>
      <div class="content">
        <div class="first">
          <h3>
            You won’t have access to:
          </h3>
          <div class="cards">
            <div class="card">
              <div class="card-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M6.00001 14.6667H10C13.3333 14.6667 14.6667 13.3333 14.6667 10V6C14.6667 2.66666 13.3333 1.33333 10 1.33333H6.00001C2.66668 1.33333 1.33334 2.66666 1.33334 6V10C1.33334 13.3333 2.66668 14.6667 6.00001 14.6667Z"
                    stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.6667 11.3867H10.4333" stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8.64668 11.3867H4.33334" stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M11.6667 8.88H7.98001" stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.18001 8.88H4.33334" stroke="#2A1E36" stroke-width="1.5" stroke-linecap="round"
                    stroke-linejoin="round" />
                </svg>
                <h4>Deploy FlyMSGs</h4>
              </div>
              <div class="card-row">
                <label>None of your FlyMSGs will work</label>
              </div>
            </div>
            <div class="card">
              <div class="card-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M6.99999 10.6667H8.99999C10.6667 10.6667 11.6667 9.46666 11.6667 8V4.60666C11.6667 3.90666 11.0933 3.33333 10.3933 3.33333H5.61333C4.91333 3.33333 4.34 3.90666 4.34 4.60666V8C4.33333 9.46666 5.33333 10.6667 6.99999 10.6667Z"
                    stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M6.33333 1.33333V3.33333" stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M9.66667 1.33333V3.33333" stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                  <path d="M8 14.6667V10.6667" stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h4>FlyMSG Plug-in</h4>
              </div>
              <div class="card-row">
                <label>The native integration into
                  Gmail, Outlook, LinkedIn, and
                  LinkedIn Sales Navigator</label>
              </div>
            </div>
            <div class="card">
              <div class="card-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M5.33334 8.13333H10" stroke="#2A1E36" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path d="M5.33334 10.8H8.25334" stroke="#2A1E36" stroke-miterlimit="10" stroke-linecap="round"
                    stroke-linejoin="round" />
                  <path
                    d="M6.66668 3.99999H9.33334C10.6667 3.99999 10.6667 3.33333 10.6667 2.66666C10.6667 1.33333 10 1.33333 9.33334 1.33333H6.66668C6.00001 1.33333 5.33334 1.33333 5.33334 2.66666C5.33334 3.99999 6.00001 3.99999 6.66668 3.99999Z"
                    stroke="#2A1E36" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M10.6667 2.67999C12.8867 2.79999 14 3.61999 14 6.66666V10.6667C14 13.3333 13.3333 14.6667 10 14.6667H6C2.66667 14.6667 2 13.3333 2 10.6667V6.66666C2 3.62666 3.11333 2.79999 5.33333 2.67999"
                    stroke="#2A1E36" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h4>FlyPlates</h4>
              </div>
              <div class="card-row">
                <label>Over 200 library templates</label>
              </div>
            </div>
            <div class="card">
              <div class="card-row">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path
                    d="M5.99999 14.6667H9.99999C13.3333 14.6667 14.6667 13.3333 14.6667 9.99999V5.99999C14.6667 2.66666 13.3333 1.33333 9.99999 1.33333H5.99999C2.66666 1.33333 1.33333 2.66666 1.33333 5.99999V9.99999C1.33333 13.3333 2.66666 14.6667 5.99999 14.6667Z"
                    stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M10.3333 12.3333C11.0667 12.3333 11.6667 11.7333 11.6667 11V5C11.6667 4.26667 11.0667 3.66667 10.3333 3.66667C9.6 3.66667 9 4.26667 9 5V11C9 11.7333 9.59333 12.3333 10.3333 12.3333Z"
                    stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                  <path
                    d="M5.66666 12.3333C6.39999 12.3333 6.99999 11.7333 6.99999 11V8.66667C6.99999 7.93334 6.39999 7.33334 5.66666 7.33334C4.93333 7.33334 4.33333 7.93334 4.33333 8.66667V11C4.33333 11.7333 4.92666 12.3333 5.66666 12.3333Z"
                    stroke="#2A1E36" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <h4>Weekly Stats</h4>
              </div>
              <div class="card-row">
                <label>View your weekly writing insights
                  and time savings</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="second" *ngIf="page > 0">
      <div class="top">
        <span>We’re always trying to improve, and we value your feedback.</span>
      </div>
      <div class="content">
        <vng-radio-group name="fav_language" orientation="vertical" [(ngModel)]="selectedOption">
          <vng-radio-button [value]="1">FlyMSG is interrupting my workflow.</vng-radio-button>
          <vng-radio-button [value]="2">It’s slowing down my computer.</vng-radio-button>
          <vng-radio-button [value]="3">It’s too complicated.</vng-radio-button>
          <vng-radio-button [value]="4">I have security or privacy concerns.</vng-radio-button>
          <vng-radio-button [value]="5">It didn’t work on specific websites.</vng-radio-button>
          <vng-radio-button [value]="6">I’m on a shared computer.</vng-radio-button>
          <vng-radio-button [value]="7">Other:</vng-radio-button>
        </vng-radio-group>
        <vng-textarea placeholder="Something else..." [rows]="4" resize="vertical"
          [(ngModel)]="description"></vng-textarea>
      </div>
    </div>
  </div>
  <div vngModalFooter class="footer">
    <button type="button" vng-button variant="ghost" class="sign-out-link" (click)="doLogout()">Yes, sign out</button>
    <button type="button" vng-button variant="accent" (click)="hideModal()">Cancel</button>
  </div>
</vng-modal>